import { AppShell } from "@/components/layout/AppShell";
import { SEO } from "@/components/SEO";
import { Hero } from "@/components/sections/Hero";
import { StatsBand } from "@/components/sections/StatsBand";
import { TechLogos } from "@/components/sections/TechLogos";
import { Leadership } from "@/components/sections/Leadership";
import { ServicesGrid } from "@/components/sections/ServicesGrid";
import { SouthAfricaSection } from "@/components/sections/SouthAfricaSection";
import { DeliveryData } from "@/components/sections/DeliveryData";
import { Testimonials } from "@/components/sections/Testimonials";
import { TechExpertise } from "@/components/sections/TechExpertise";
import { ComplianceSection } from "@/components/sections/ComplianceSection";

import { ContactSection } from "@/components/sections/ContactSection";

const HomePage = () => {
  return (
    <AppShell>
      <SEO
        title="IntelliBPO | Skilled People Dedicated to Your Business"
        description="Fully managed remote and office-based teams from South Africa for customer support, healthcare billing, virtual assistants and sales."
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "IntelliBPO Johannesburg",
            url: "https://intellibpo.com",
            telephone: "+27870495570",
            email: "hello@intellibpo.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "3rd Floor, 26 Girton Road, Parktown",
              addressLocality: "Johannesburg",
              addressRegion: "Gauteng",
              addressCountry: "ZA",
            },
            openingHours: "Mo-Fr 08:00-17:00",
          },
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "IntelliBPO Durban",
            url: "https://intellibpo.com",
            telephone: "+27870495570",
            email: "hello@intellibpo.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "1D Umhlanga Boulevard, 1 Lunar Row, New Town Centre Umhlanga",
              addressLocality: "Durban",
              addressRegion: "KwaZulu-Natal",
              addressCountry: "ZA",
            },
            openingHours: "Mo-Fr 08:00-17:00",
          },
        ]}
      />

      <Hero />
      <StatsBand />
      <TechLogos />
      <Leadership />
      <ServicesGrid />
      <SouthAfricaSection />
      <DeliveryData />
      <ComplianceSection />
      <Testimonials />
      <TechExpertise />
      
      <ContactSection />
    </AppShell>
  );
};

export default HomePage;
